import { render } from "./ribbon.vue?vue&type=template&id=6a8e1fd0&scoped=true&ts=true"
import script from "./ribbon.component.ts?vue&type=script&lang=ts"
export * from "./ribbon.component.ts?vue&type=script&lang=ts"

import "./ribbon.vue?vue&type=style&index=0&id=6a8e1fd0&scoped=true&lang=css"

import exportComponent from "/home/haris/IdeaProjects/bloodpressure/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6a8e1fd0"]])

export default __exports__